/** Aviso legal corporativo (login público SSO). */
export const LEGAL_NOTICE_URL = 'https://www.imparcapital.com/aviso-legal/';

export const DASHBOARD = '/';
export const PROJECTS = '/projects';
export const FOUND_PROJECTS = '/vehicles-projects';
export const FUNDS = '/investment-vehicles';
export const HISTORIC = '/historic';
export const OPPORTUNITIES = '/opportunities';
export const OPPORTUNITIES_DETAIL = '/opportunities-detail';
export const OPPORTUNITIES_DETAIL_ID = '/opportunities/:id';
export const CALENDAR = '/calendar';
export const DOCUMENTATION = '/documentation';
export const PROFILE = '/profile';
export const ACTIVE_PROJECTS = '/active-projects';

export const ADMIN_ACCOUNTS = '/admin';
export const ADMIN_PROFILE = '/admin/profile';
export const ADMIN_ACCOUNT_PROJECTS = '/admin/accounts/:id/projects/:type';
export const ADMIN_ACCOUNT_INVESTORS = '/admin/accounts/:id/investors/:type';
export const ADMIN_INVESTORS = '/admin/investors';
export const ADMIN_INVESTOR_ACCOUNTS = '/admin/investors/:id/accounts/:type';
export const ADMIN_INVESTOR_PROJECTS = '/admin/investors/:id/projects/:type';
export const ADMIN_INVESTOR_CHANGE_PASSWORD = '/admin/investors/:id/change-password/:type';
export const ADMIN_PROJECTS = '/admin/projects';
export const ADMIN_PROJECT_ACCOUNTS = '/admin/projects/:id/accounts/:type';
export const ADMIN_PROJECT_INVESTORS = '/admin/projects/:id/investors/:type';
export const ADMIN_INVITATIONS = '/admin/invitations';
export const ADMIN_EVENTS = '/admin/events';
export const ADMIN_DOCS_REQUEST_TEMPLATE = '/admin/docs-request-templates';
export const ADMIN_CRM = '/admin/crm';
export const ADMIN_DOCS_GENERAL = '/admin/documentation-dashboard';
export const ADMIN_PROCESSES = '/admin/processes';

export const ROUTE_ADMIN_ACCOUNTS = '/';
export const ROUTE_ADMIN_PROFILE = '/profile';
export const ROUTE_ADMIN_ACCOUNT_PROJECTS = '/accounts/:id/projects/:type';
export const ROUTE_ADMIN_ACCOUNT_INVESTORS = '/accounts/:id/investors/:type';
export const ROUTE_ADMIN_ACCOUNT_DOCS = '/accounts/:id/docs/:type';
export const ROUTE_ADMIN_INVESTORS = '/investors';
export const ROUTE_ADMIN_INVESTOR_ACCOUNTS = '/investors/:id/accounts/:type';
export const ROUTE_ADMIN_INVESTOR_PROJECTS = '/investors/:id/projects/:type';
export const ROUTE_ADMIN_INVESTOR_CHANGE_PASSWORD = '/investors/:id/change-password/:type';
export const ROUTE_ADMIN_PROJECTS = '/projects';
export const ROUTE_ADMIN_PROJECT_ACCOUNTS = '/projects/:id/accounts/:type';
export const ROUTE_ADMIN_PROJECT_INVESTORS = '/projects/:id/investors/:type';
export const ROUTE_ADMIN_INVITATIONS = '/invitations';
export const ROUTE_ADMIN_EVENTS = '/events';
export const ROUTE_ADMIN_DOCS_REQUEST_TEMPLATE = '/docs-request-templates';
export const ROUTE_ADMIN_CRM = '/crm';
export const ROUTE_ADMIN_DOCS = '/documentation';
export const ROUTE_ADMIN_DOCS_GENERAL = '/documentation-dashboard';
export const ROUTE_ADMIN_PROCESSES = '/processes';
